import React from "react";

import {
    Box,
    HStack,
    Button,
    Input,
    InputGroup,
    InputLeftElement,
    Flex,
    GridItem,
    Grid,
    SimpleGrid,
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    Heading,
    Text,
    Progress,
    Container,
  } from '@chakra-ui/react';
import EditCard from './EditCard'
import './Edit.scss'
import { SearchIcon } from "@chakra-ui/icons";
function Edit() {
  return (
    <Container maxW={'1820px'} mt={'60px'}> 
    <div className="generate">
      <HStack>
        <Box>
          <h1 className='greet'>EDIT PRODUCT</h1> 
          <p className='render__page'>MERCHANT <span>/ EDIT PRODUCT</span></p>  
        </Box>
      </HStack>
      <Card className="card" mt={'51px'}>
        <CardHeader className="card_header">
          <Heading className="heading" size='md'>EDIT PRODUCT</Heading>
          <Text className="text">Edit Product Details Here</Text>
        </CardHeader>
        <EditCard />
      </Card>
    </div>
    </Container>
    );
}

export default Edit;
